export const assignmentContentProgressFilter = 'assignmentContentProgressFilter';

export interface AssignmentContentProgressFilterEvent {
  searchText: string;
  assignmentId?: number;
  requestId?: number;
}
